module.exports = __webpack_public_path__ + "img/generic-user-icon.3bb2a5c8.png";